function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * An autogenerated component that renders the PERIOD iconograpy in SVG.
 *
 * Generated with: https://gist.github.com/crm416/3c7abc88e520eaed72347af240b32590.
 */
var React = require('react');

var Period = function (_React$Component) {
    _inherits(Period, _React$Component);

    function Period() {
        _classCallCheck(this, Period);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Period.prototype.render = function render() {
        return React.createElement(
            "svg",
            { width: "48", height: "48", viewBox: "0 0 48 48" },
            React.createElement(
                "g",
                { fill: "none", fillRule: "evenodd" },
                React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
                React.createElement("circle", { fill: this.props.color, cx: "24", cy: "30", r: "2" })
            )
        );
    };

    return Period;
}(React.Component);

Period.propTypes = {
    color: React.PropTypes.string.isRequired
};


module.exports = Period;


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/src/components/iconography/period.js
 ** module id = 599
 ** module chunks = 0 2
 **/